import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../store/app.reducers';
import * as AuthActions from '../store/auth.actions';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false
})
export class LogoutComponent implements OnInit {
  constructor(private store: Store<AppState>) { }
  ngOnInit() {
    this.store.dispatch(new AuthActions.Logout());
  }

}
